import { useEffect } from "react";
import { ProductType } from "../../api/model/common";

export const memorizeIsActual = (type: ProductType) => {
    const expires_in = Number(localStorage.getItem(`${type.toUpperCase()}_expires_in`));
    const quotation =
        localStorage.getItem(`${type}_quotation`) ||
        localStorage.getItem(`${type.toUpperCase()}_quotation`);
    return !isNaN(expires_in) && expires_in > Date.now() && !!quotation;
};

export const useCheckingForMemorizing = (
    type: ProductType,
    fetchFunction: () => Promise<void>,
    memorizingFunction: () => Promise<void>,
    catchFunction: (error: unknown) => void,
) => {
    useEffect(() => {
        try {
            const isActual = memorizeIsActual(type);
            if (isActual) {
                memorizingFunction();
            } else {
                fetchFunction();
                localStorage.setItem(`${type.toUpperCase()}_expires_in`, `${Date.now() + 3600000}`); //термін запамятовування 1 година
            }
        } catch (e) {
            catchFunction(e);
        }
    }, []);
};
